import { connect } from 'react-redux';
import AdminWellhubUnitsHistoryPage from 'pages/AdminWellhubUnitsHistoryPage';
import AdminActions from 'store/adminPanel/actions';

const mapStateToProps = state => {
  return {
    loadingGympassHistory: state.adminPanel.loadingGympassHistory,
    gympassHistoryData: state.adminPanel.gympassHistoryData,
  };
};
const mapDispatchToProps = {
  loadGympassHistory: AdminActions.Creators.adminGympassHistoryRequest,
};
export default connect(mapStateToProps, mapDispatchToProps)(AdminWellhubUnitsHistoryPage);
